const secondary = {
    social_bind_with: '既にアカウントを持っていますか？{{methods, list(type: disjunction;)}}をソーシャルアイデンティティにリンクするためにサインインしてください。',
};
export default Object.freeze(secondary);
